module.exports = __webpack_public_path__ + "static/media/not-found.2779d8d0.svg";